// Canvas geometry constants shared by LivePreview and its interaction hooks.
export const A4_W = 595;
export const A4_H = 842;
export const PAGE_GAP = 16;
export const PAGE_CENTER_X = A4_W / 2;
export const GUIDE_THRESHOLD = 20;
export const SNAP_THRESHOLD = 8;
export const FLOW_GAP = 12;

/** CSS width for each non-`full` flow width — shared by the editor preview and
 *  the live A4 render so the two never drift. */
export const FLOW_WIDTH_MAP: Record<'1/2' | '2/3' | '1/3' | '1/4', string> = {
  '1/2': '50%',
  '2/3': '66.67%',
  '1/3': '33.33%',
  '1/4': '25%',
};
